import { axiosInstance } from "../axios";
import { Login, Token } from "./user.types";

export const loginUser = (data: Login) => {
    return axiosInstance.request<Token>({
        method: "POST",
        url: "/login",
        data,
    });
};
